// API Base URL
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// ByBit Theme Colors
export const COLORS = {
  primary: '#F7A600',
  background: '#0B0E11',
  card: '#1E2026',
  border: '#2B2F36',
  text: '#EAECEF',
  textSecondary: '#848E9C',
  success: '#2EBD85',
  danger: '#F6465D',
  warning: '#F0B90B',
};

// User Roles
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
};

// Trade Types
export const TRADE_TYPES = {
  SPOT: 'spot',
  FUTURES: 'futures',
};

// Trade Sides
export const TRADE_SIDES = {
  LONG: 'long',
  SHORT: 'short',
};

// Transaction Status
export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
};

// Supported Cryptocurrencies
export const SUPPORTED_CRYPTOS = [
  { symbol: 'BTCUSDT', name: 'Bitcoin', base: 'BTC', quote: 'USDT' },
  { symbol: 'ETHUSDT', name: 'Ethereum', base: 'ETH', quote: 'USDT' },
  { symbol: 'BNBUSDT', name: 'Binance Coin', base: 'BNB', quote: 'USDT' },
  { symbol: 'SOLUSDT', name: 'Solana', base: 'SOL', quote: 'USDT' },
  { symbol: 'XRPUSDT', name: 'Ripple', base: 'XRP', quote: 'USDT' },
  { symbol: 'ADAUSDT', name: 'Cardano', base: 'ADA', quote: 'USDT' },
  { symbol: 'DOGEUSDT', name: 'Dogecoin', base: 'DOGE', quote: 'USDT' },
  { symbol: 'MATICUSDT', name: 'Polygon', base: 'MATIC', quote: 'USDT' },
  { symbol: 'DOTUSDT', name: 'Polkadot', base: 'DOT', quote: 'USDT' },
  { symbol: 'AVAXUSDT', name: 'Avalanche', base: 'AVAX', quote: 'USDT' },
];

// Deposit Addresses (will be fetched from API)
export const DEPOSIT_CURRENCIES = [
  { value: 'USDT', label: 'USDT (TRC20)', chain: 'TRC20' },
  { value: 'BTC', label: 'Bitcoin (BTC)', chain: 'BTC' },
  { value: 'ETH', label: 'Ethereum (ETH)', chain: 'ETH' },
];

// Leverage Options
export const LEVERAGE_OPTIONS = [
  1, 2, 3, 5, 10, 20, 25, 50, 75, 100
];

// Language Options
export const LANGUAGES = [
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
];
